import { memo } from "react";
import Login from "components/auth/login/login";

const LoginCom = () => {
    return (
        <Login />
    )
}

export default memo(LoginCom);